import React from 'react'
import './EqxEnvironmentBanner.css'

interface EqxEnvironmentBannerProps {
    tenant?: string | null
    environment?: string | null
    instance?: string | null
}

function toThreeDigitInstance(instance?: string | null): string {
    const raw = String(instance ?? '').trim()
    if (!raw) return ''
    if (!/^\d+$/.test(raw)) return raw
    return raw.padStart(3, '0')
}

function backgroundColorForEnvironment(environment?: string | null): string | null {
    const env = String(environment ?? '').trim().toLowerCase()
    if (!env || env === 'prod') return null
    if (env === 'dev') return '#f44336'
    if (env === 'qa') return '#ff9800'
    if (env === 'rc') return '#ffeb3b'
    if (env === 'sandbox') return '#4caf50'
    return '#607d8b'
}

const EqxEnvironmentBanner = (props: EqxEnvironmentBannerProps) => {
    const bg = backgroundColorForEnvironment(props.environment)
    React.useEffect(() => {
        if (!bg) return
        document.body.classList.add('has-environment-banner')
        return () => {
            document.body.classList.remove('has-environment-banner')
        }
    }, [bg])

    if (!bg) return null

    const tenant = String(props.tenant ?? '').trim()
    const environment = String(props.environment ?? '').trim() || '-'
    const instance = toThreeDigitInstance(props.instance)

    return (
        <div id="environment-banner" style={{ backgroundColor: bg, borderColor: bg }}>
            <span className="fw-bold">
                {tenant && (
                    <span className="me-2">
                        Tenant <span className="badge bg-white text-dark" id="env-badge">{tenant}</span>
                    </span>
                )}
                <span>
                    Environment <span className="badge bg-white text-dark" id="env-badge">{environment}</span>
                </span>
                {instance && (
                    <span className="ms-2">
                        Instance <span className="badge bg-white text-dark" id="env-badge">{instance}</span>
                    </span>
                )}
            </span>
        </div>
    )
}

export default EqxEnvironmentBanner
